import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"min-height":"45vw"} }
const _hoisted_2 = { class: "pl-3 w-100" }
const _hoisted_3 = { class: "mx-3 mb-4" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex justify-content-end m-3"
}

import Api from '@/services/api/ApiServiceFabrick';
import AuthorityCacheApi from '@/services/models/AuthorityCacheApi';
import { useAuth } from '@/services/user/Auth0UserProvider';
import { useRoute, useRouter } from 'vue-router';
import { ref, onMounted, onBeforeUnmount } from 'vue';
import i18n from '@/lang/i18n';
import getOperationOffice from '@/types/responses/getOperationOffice';
import getAccount from '@/types/responses/getAccount';
import OperationOfficeRow from '@/components/GpsTrackerSetting/OperationOfficeRow.vue';
import TripStartTimeRow from '@/components/GpsTrackerSetting/TripStartTimeRow.vue';
import CommonDriverRow from '@/components/GpsTrackerSetting/CommonDriverRow.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'GpsTrackerSettingForm',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const route = useRoute();
const router = useRouter();
const { loginWithRedirect } = useAuth();
const showableUpdateButton = ref(false);
const isUpdating = ref(false);
const gpsTrackerSettingId = ref<number | undefined>(undefined);
const operationOffice = ref<getOperationOffice | null>(null);
const initialOperationOfficeId = ref<number | undefined>(undefined);
const initialDriverAccountId = ref<number | undefined>(undefined);
const tripStartTime = ref('00:00');
const selectedDriver = ref<getAccount | undefined>(undefined);
const errors = ref<Record<string, string[]>>({});

onMounted(async () => {
  props.switchContentLoading(true);
  document.title = i18n.global.t('pages.gpsTrackerSetting.title');
  gpsTrackerSettingId.value = route.params.id ? Number(route.params.id) : undefined;

  AuthorityCacheApi.getWithParse().then((authorityList) => {
    showableUpdateButton.value = !!authorityList['octlink.gps_tracker_settings.update'];
  });

  if (gpsTrackerSettingId.value) {
    const response = await Api().getGpsTrackerSetting(gpsTrackerSettingId.value)
      .catch((error: any) => {
        if (error?.request?.status === 403) {
          props.showFlash(i18n.global.t('pages.common.messages.forbidden'), 'error', true);
          router.push('/gps-tracker-settings');
        }
      });

    if (response) {
      initialOperationOfficeId.value = response.operation_office_id;
      initialDriverAccountId.value = response.common_driver_account_id ?? undefined;
      selectedDriver.value = undefined;
      if (response.trip_start_time) {
        tripStartTime.value = response.trip_start_time.slice(0, 5);
      }
    }
  }

  props.switchContentLoading(false);
});

onBeforeUnmount(() => {
  props.switchContentLoading(false);
});

function makeParams() {
  if (!operationOffice.value) {
    errors.value = {
      operation_office_id: [i18n.global.t('pages.gpsTrackerSetting.messages.operationOfficeRequired')]
    };
    return null;
  }
  return {
    operation_office_id: operationOffice.value.id,
    trip_start_time: tripStartTime.value,
    common_driver_account_id: selectedDriver.value?.id ?? null,
  };
}

function submit() {
  const params = makeParams();
  if (!params) return;
  isUpdating.value = true;
  Api()
    .upsertGpsTrackerSetting(params, gpsTrackerSettingId.value)
    .then(() => {
      props.showFlash(i18n.global.t('pages.common.messages.success'), 'success', true);
      router.push({ name: 'GpsTrackerSettingList' });
    })
    .catch((error: any) => {
      errorHandle(error.response);
    })
    .finally(() => {
      isUpdating.value = false;
    });
}

function errorHandle(res: { status: number; data: { errors: Record<string, string[]> } }) {
  switch (res?.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } });
      break;
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.notEditAuthority'), 'error', true);
      showableUpdateButton.value = false;
      break;
    case 422:
      errors.value = res.data.errors;
      break;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.gpsTrackerSetting.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(OperationOfficeRow, {
        modelValue: operationOffice.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((operationOffice).value = $event)),
        "initial-operation-office-id": initialOperationOfficeId.value,
        "error-messages": errors.value['operation_office_id'],
        disabled: !!gpsTrackerSettingId.value
      }, null, 8, ["modelValue", "initial-operation-office-id", "error-messages", "disabled"]),
      _createVNode(TripStartTimeRow, {
        modelValue: tripStartTime.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tripStartTime).value = $event)),
        "error-messages": errors.value['trip_start_time']
      }, null, 8, ["modelValue", "error-messages"]),
      _createVNode(CommonDriverRow, {
        modelValue: selectedDriver.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedDriver).value = $event)),
        "operation-office": operationOffice.value,
        "initial-driver-account-id": initialDriverAccountId.value,
        "error-messages": errors.value['common_driver_account_id']
      }, null, 8, ["modelValue", "operation-office", "initial-driver-account-id", "error-messages"]),
      (showableUpdateButton.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, { to: { name: 'GpsTrackerSettingList' } }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, { class: "ma-2 reset-btn" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(i18n).global.t('common.cancelBtn')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              class: "ma-2 exec-btn",
              onClick: submit,
              loading: isUpdating.value
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
              ]),
              _: 1
            }, 8, ["loading"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})